<div class="w-full" #pageContainer>
    <div class="bg-card shadow rounded-2xl m-4">
        <div class="flex justify-between p-5 px-8 bg-primary rounded-t-2xl ">
            <div class="flex flex-col">
                <div class="text-3xl text-white"><b>
                        {{ wellString }}
                    </b></div>

                <div *ngIf="!isViewOnly" class="flex flex-row items-center">
                    <span class="text-white"><i>Please complete all the required fields. The information will be
                            forwarded to the Management of Change after all fields are filled in.</i></span>
                </div>
            </div>

            <div class="self-center" style="color: #dbd3d3;font-size: medium">
                {{ isViewOnly ? 'View' : 'Edit' }} Corrective Maintenance Details
            </div>
        </div>

        <div class="p-12">
            <form [formGroup]="cmForm">
                <div class="flex justify-end mb-4 mx-2" *ngIf="cmStatus">
                    <span style="font-size: medium;" [ngClass]="{
                            'py-1 px-7': true,
                            'idleBadge': cmStatus == status.OPEN,
                            'successBadge': cmStatus == status.APPROVED || cmStatus == status.CLOSED,
                            'failedBadge': cmStatus == status.REJECTED,
                            'warningBadge': cmStatus == status.READY
                        }">
                        {{ cmStatus ?? "-" }}
                    </span>
                </div>

                <div class="grid grid-cols-4 gap-x-8">
                    <mat-form-field class="col-span-2">
                        <mat-label>Field Name</mat-label>
                        <input matInput formControlName="fieldLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Platform Name</mat-label>
                        <input matInput formControlName="platformLongName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Well String Name</mat-label>
                        <input matInput formControlName="wellStringShortName" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Source</mat-label>
                        <input matInput formControlName="source" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Rectified Date</mat-label>
                        <input matInput [matDatepicker]="rectifiedDate" formControlName="dateRectified" />
                        <mat-datepicker-toggle matIconSuffix [for]="rectifiedDate"></mat-datepicker-toggle>
                        <mat-datepicker #rectifiedDate></mat-datepicker>
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 gap-y-4 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Failed Equipment</mat-label>
                        <mat-select placeholder="Select Fail Equipment" formControlName="failEquipment">
                            <mat-option *ngFor="let failEquipment of failEquipmentList" [value]="failEquipment.name"> {{
                                failEquipment.name }} </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Failure Date</mat-label>
                        <input matInput [matDatepicker]="failureDate" formControlName="failureDate" />
                        <mat-datepicker-toggle matIconSuffix [for]="failureDate"></mat-datepicker-toggle>
                        <mat-datepicker #failureDate></mat-datepicker>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Problem Reported</mat-label>
                        <input matInput formControlName="problemReported" />

                        <mat-error
                            *ngIf="cmForm.get('problemReported')?.hasError('required') && cmForm.get('problemReported')?.touched">
                            Problem Reported is required.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Risk Ranking</mat-label>
                        <input matInput formControlName="riskRanking" />
                    </mat-form-field>

                    <mat-form-field class="col-span-4">
                        <mat-label>Detail Description</mat-label>
                        <textarea matInput formControlName="detailDesc" rows="5"></textarea>

                        <mat-error
                            *ngIf="cmForm.get('detailDesc')?.hasError('required') && cmForm.get('detailDesc')?.touched">
                            Detail Description is required.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="col-span-4">
                        <mat-label>Forward Action Plan</mat-label>
                        <textarea matInput formControlName="forwardActionPlan" rows="5"></textarea>

                        <mat-error
                            *ngIf="cmForm.get('forwardActionPlan')?.hasError('required') && cmForm.get('forwardActionPlan')?.touched">
                            Forward Action Plan is required.
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="col-span-4">
                        <mat-label>Remark</mat-label>
                        <textarea matInput formControlName="remark" rows="5"></textarea>
                    </mat-form-field>
                </div>

                <div class="divider my-6"></div>

                <div class="grid grid-cols-4 gap-x-8 mt-4">
                    <mat-form-field class="col-span-2">
                        <mat-label>Updated By</mat-label>
                        <input matInput formControlName="updatedBy" />
                    </mat-form-field>

                    <mat-form-field class="col-span-2">
                        <mat-label>Updated Date</mat-label>
                        <input matInput formControlName="updatedDate" />
                    </mat-form-field>

                    <ng-container *ngIf="cmStatus == status.APPROVED || cmStatus == status.CLOSED">
                        <mat-form-field class="col-span-2">
                            <mat-label>Approved By</mat-label>
                            <input matInput formControlName="approvedBy" />
                        </mat-form-field>

                        <mat-form-field class="col-span-2">
                            <mat-label>Approved Date</mat-label>
                            <input matInput formControlName="approvedDate" />
                        </mat-form-field>
                    </ng-container>
                </div>
            </form>
        </div>
    </div>
</div>


<div class="fixed bottom-0 right-0 p-4 bg-card w-full" *ngIf="!isViewOnly">
    <div class="flex justify-end">
        <button class="btn btn-primary mx-2" (click)="location.back()">
            Back
        </button>

        <button *ngIf="cmStatus != status.READY" class="btn btn-outline btn-default"
            [disabled]="!hasFormChanged() || !cmForm.valid" (click)="updateCM()">
            Save
        </button>


        <button *ngIf="cmStatus == status.READY" [matMenuTriggerFor]="menu" class="btn btn-outline btn-default"
            [disabled]="cmStatus == status.REJECTED || cmStatus == status.APPROVED || cmStatus == status.CLOSED || (cmStatus == status.OPEN && cmSource == 'FN')">
            Save
            <mat-icon>
                <mat-icon>expand_less</mat-icon>
            </mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item *ngIf="cmStatus == status.OPEN && cmSource != 'FN'" (click)="updateCM()">
                <span>Save</span>
            </button>
            <button mat-menu-item *ngIf="cmStatus == status.READY" (click)="updateCMStatus(status.REJECTED)">
                <span>Reject</span>
            </button>
            <button mat-menu-item *ngIf="cmStatus == status.READY" (click)="updateCMStatus(status.APPROVED)">
                <span>Approve</span>
            </button>
        </mat-menu>
    </div>
</div>